/**
 * === BLAZE CHANGE ===
 * File added for Blaze geolocation/currency overlay ONLY.
 * Do not remove without checking with Blaze.
 *
 * SAFE SCOPE:
 * - Touches ONLY elements inside .blz_os_country_list (Blaze UI)
 * - Does NOT modify theme sections, cart, header layout, products, or checkout
 * - CSS only hides rows after this script adds blaze-specific classes
 *
 * Purpose: show each currency once (EUR once + all other currencies).
 */
(function () {
  'use strict';

  var HIDE_ROW_CLASS = 'blz-hide-duplicate-currency-row';
  var HIDE_TEXT_CLASS = 'blz-hide-duplicate-currency';
  var LIST_SELECTOR = '.blz_os_country_list';
  var ITEM_SELECTOR = '.blz_os_list_item';
  var TEXT_SELECTOR = '.blz_os_first_text';
  var debounceTimer = null;
  var observer = null;

  function deduplicateBlazeCurrencies() {
    var lists = document.querySelectorAll(LIST_SELECTOR);
    if (!lists.length) return;

    lists.forEach(function (list) {
      var seenCurrencies = Object.create(null);

      list.querySelectorAll(ITEM_SELECTOR).forEach(function (item) {
        // Extra guard: never touch nodes outside Blaze list markup
        if (!item.closest(LIST_SELECTOR)) return;

        var currencyEl = item.querySelector(TEXT_SELECTOR);
        if (!currencyEl) return;

        var currency = (currencyEl.textContent || '').trim().toUpperCase();
        if (!currency) return;

        if (seenCurrencies[currency]) {
          item.classList.add(HIDE_ROW_CLASS);
          currencyEl.classList.add(HIDE_TEXT_CLASS);
        } else {
          seenCurrencies[currency] = true;
          item.classList.remove(HIDE_ROW_CLASS);
          currencyEl.classList.remove(HIDE_TEXT_CLASS);
        }
      });
    });
  }

  function scheduleDeduplicate() {
    if (debounceTimer) window.clearTimeout(debounceTimer);
    debounceTimer = window.setTimeout(deduplicateBlazeCurrencies, 150);
  }

  function start() {
    deduplicateBlazeCurrencies();

    if (observer || !document.body) return;

    observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        var node = m.target;
        if (
          (node && node.closest && node.closest(LIST_SELECTOR)) ||
          (node && node.querySelector && node.querySelector(LIST_SELECTOR))
        ) {
          scheduleDeduplicate();
          return;
        }
        // Also react when Blaze injects the list into the page
        if (m.addedNodes && m.addedNodes.length) {
          for (var j = 0; j < m.addedNodes.length; j++) {
            var added = m.addedNodes[j];
            if (added.nodeType !== 1) continue;
            var isList =
              (added.matches && added.matches(LIST_SELECTOR)) ||
              (added.querySelector && added.querySelector(LIST_SELECTOR)) ||
              (added.classList && added.classList.contains('blz_os_list_item'));
            if (isList) {
              scheduleDeduplicate();
              return;
            }
          }
        }
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
